import { useState } from 'owa-react';
import { lazyGovern, GovernPriority } from 'owa-tti';
import { lazyInitializeActivityFeed, lazyLoadActivityFeed } from 'owa-activity-feed';
import { lazyInitializeNotificationManager } from 'owa-notification-manager';
import React from 'react';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import updateNotificationsBadge from './updateNotificationsBadge';

export default function useActivityFeed(showActivityFeed: boolean): void {
    const [refreshNotificationsSwitch, setRefreshNotificationsSwitch] = useState<boolean>(false);
    const setNotificationsToRefresh = React.useCallback(() => {
        if (showActivityFeed) {
            setRefreshNotificationsSwitch(!refreshNotificationsSwitch);
            updateNotificationsBadge();
        }
    }, [showActivityFeed]);

    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();

    React.useEffect(() => {
        if (showActivityFeed) {
            lazyInitializeNotificationManager.importAndExecute();
            lazyGovern.importAndExecute({
                task: () => lazyInitializeActivityFeed.importAndExecute(),
                priority: GovernPriority.Idle,
                name: 'lazyInitializeActivityFeed',
            });

            lazyLoadActivityFeed.importAndExecute(mailboxInfo, setNotificationsToRefresh);
        }
    }, [showActivityFeed]);
}
